<div class="toggle" [class.overflowed]="overflowed">
    <ng-content select="liebherr-column-toggle"></ng-content>
</div>

<div class="content" #content>
    <ng-content select="table"></ng-content>
</div>
